export const TYPE_SOLID_MOISTURE = 'pf'
export const TYPE_ACCUMULATED_TEMPERATURE = 'at'
